/**
 * Professional Guardian name suggestion — shared Levenshtein / similarity (features/bonds).
 */

export const normalizeName = (str) =>
  (str || "")
    .toLowerCase()
    .replace(/[^a-z\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const levenshteinDistance = (a, b) => {
  const s = normalizeName(a);
  const t = normalizeName(b);
  const n = s.length;
  const m = t.length;
  if (n === 0) return m;
  if (m === 0) return n;
  const d = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0));
  for (let i = 0; i <= n; i++) d[i][0] = i;
  for (let j = 0; j <= m; j++) d[0][j] = j;
  for (let i = 1; i <= n; i++) {
    for (let j = 1; j <= m; j++) {
      const cost = s[i - 1] === t[j - 1] ? 0 : 1;
      d[i][j] = Math.min(
        d[i - 1][j] + 1,
        d[i][j - 1] + 1,
        d[i - 1][j - 1] + cost
      );
    }
  }
  return d[n][m];
};

export const similarityScore = (a, b) => {
  const sA = normalizeName(a);
  const sB = normalizeName(b);
  if (!sA || !sB) return 0;
  const dist = levenshteinDistance(sA, sB);
  let score = 1 - dist / Math.max(sA.length, sB.length);
  if (sA.includes(sB) || sB.includes(sA)) score = Math.max(score, 0.9);
  return score;
};
